import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives/responsive";

import { JswDoubleFeatureCard } from "./";

const containerStyles = css({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    alignItems: "center",
    [media.below.lg]: {
        padding: "5% 10% 0 10%"
    }
});

const titleStyles = css({
    color: "#000",
    textAlign: "center",
    fontFeatureSettings: "'clig' off, 'liga' off",
    fontFamily: "var(--bxp-charlie-display-font-family)",
    fontSize: "40px",
    fontStyle: "normal",
    fontWeight: "700",
    lineHeight: "48px",
    [media.below.lg]: {
        fontSize: "30px"
    }
});

const cardContainerStyles = css({
    display: "flex",
    justifyContent: "center",
    gap: "30px",
    marginBlockStart: "34px",
    zIndex: "1",
    [media.below.lg]: {
        flexDirection: "column",
        alignItems: "center",
        marginBlockStart: "32px",
        gap: "32px"
    }
});

const blackFooterStyles = css({
    zIndex: "-1",
    marginBlockStart: "-7%",
    width: "100%"
});

export const JswDoubleFeatureSection = () => {
    const doubleFeatureItems = [
        {
            title: "Simple, yet scalable",
            description:
                "No matter what you're trying to get done, templates, workflows, and automations help you tackle projects of any size.",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-1.webp"
        },
        {
            title: "Built for you",
            description:
                "No team works the same. If you need boards, backlogs, calendars, or lists to manage work, Jira matches your way of working, so you feel at home.",
            image: "https://wac-cdn.atlassian.com/misc-assets/webp-images/double-feature-2.webp"
        }
    ];

    return (
        <div>
            <div css={containerStyles}>
                <div css={titleStyles}>
                    {"Made for complex projects or everyday tasks"}
                </div>
                <div css={cardContainerStyles}>
                    {doubleFeatureItems.map((item, index) => (
                        <JswDoubleFeatureCard
                            key={index}
                            title={item.title}
                            description={item.description}
                            image={item.image}
                        />
                    ))}
                </div>
            </div>
            <img
                src="https://wac-cdn.atlassian.com/misc-assets/webp-images/dark-shape.webp"
                alt=""
                css={blackFooterStyles}
            />
        </div>
    );
};
JswDoubleFeatureSection.displayName = "JswDoubleFeatureSection";
